<template>
    <div style="width:100%;float:left;">
        <hr :style="'width:' + width + '%;height:2px;background-color:#e0e0e0;margin-left:auto;margin-right:auto;'" />
    </div>
</template>
<script>
var methods = {}

export default {
    // ===Component name
    name: "Spacer",
    // ===Props passed to component
    props: ['width'],
    // ===Components used by this component
    components: {

    },
    // ====component Data properties
    data(){
        return{

        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {

    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
